module.exports = __webpack_public_path__ + "static/media/download.52f73669.png";